module.exports = __webpack_public_path__ + "static/media/icon-search.7d19281b.svg";